import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

type ProjektprognosInteractionContextProviderProps = {
  children: ReactNode
}

type ProjektprognosInteractionContextStates = {
  loadProjektprognos: boolean
  setLoadProjektprognos: Dispatch<SetStateAction<boolean>>
  errors: Error[]
  setErrors: Dispatch<SetStateAction<Error[]>>
  refreshLoading: boolean
  setRefreshLoading: Dispatch<SetStateAction<boolean>>
}

export const ProjektprognosInteractionContext =
  createContext<ProjektprognosInteractionContextStates | null>(null)

export const ProjektprognosInteractionContextProvider = ({
  children,
}: ProjektprognosInteractionContextProviderProps) => {
  const [loadProjektprognos, setLoadProjektprognos] = useState(true)
  const [errors, setErrors] = useState<Error[]>([])

  const [refreshLoading, setRefreshLoading] = useState(false)

  const value: ProjektprognosInteractionContextStates = {
    loadProjektprognos,
    setLoadProjektprognos,
    errors,
    setErrors,
    refreshLoading,
    setRefreshLoading,
  }

  return (
    <ProjektprognosInteractionContext.Provider value={value}>
      {children}
    </ProjektprognosInteractionContext.Provider>
  )
}

export const useProjektprognosInteractionContext = () => {
  const context = useContext(ProjektprognosInteractionContext)

  if (!context) {
    throw Error(
      'useProjektprognosInteractionContext must be used within a ProjektprognosInteractionContextProvider'
    )
  }

  return context
}
